export class CalcApi {
    public id: number;
    public trigger_url: string;
    public trigger_json: string;
    public created_by: string;
    public updated_by: string;
    public created_dt: Date;
    public updated_dt: Date;

    constructor() {
        this.id = null;
        this.trigger_url = null;
        this.trigger_json = null;
        this.created_by = null;
        this.created_dt = null;
        this.updated_by = null;
        this.updated_dt = null;
    }
}
